<template>
    <div class="photo-gallery">
        <Swiper
            ref="swiperRef"
            v-bind="swiperOptions"
            class="photo-gallery__swiper"
            @swiper="onSwiper"
        >
            <SwiperSlide
                v-for="(image, index) in images"
                :key="index"
                class="photo-gallery__slide"
            >
                <img :src="image" class="photo-gallery__image" />
            </SwiperSlide>
        </Swiper>

        <div class="photo-gallery__navigation">
            <button class="photo-gallery__prev" @click="prevSlide">❮</button>
            <button class="photo-gallery__next" @click="nextSlide">❯</button>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import 'swiper/css';
    import 'swiper/css/navigation';

    import { PropType, ref } from 'vue';
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import type { Swiper as SwiperClass } from 'swiper';

    defineProps({
        images: {
            type: Array as PropType<string[]>,
            required: true,
        },
    });

    const swiperRef = ref(null);
    const swiperInstance = ref<SwiperClass | null>(null);

    // Настройки слайдера
    const swiperOptions = {
        slidesPerView: 'auto',
        spaceBetween: 4,
        navigation: false,
        loop: true,
    };

    function onSwiper(instance: SwiperClass): void {
        swiperInstance.value = instance;
    }

    function nextSlide(): void {
        if (swiperInstance.value) {
            swiperInstance.value.slideNext();
        }
        else {
            console.error('Swiper instance is not initialized');
        }
    }

    function prevSlide(): void {
        if (swiperInstance.value) {
            swiperInstance.value.slidePrev();
        }
        else {
            console.error('Swiper instance is not initialized');
        }
    }
</script>

<style lang="scss" scoped>
    @use './PhotoGallery.scss' as *;
</style>
